<div class="oauth-button-container">
  <p>or</p>
  <dx-button
    width="100%"
    icon="assets/icons/google-logo.svg"
    text="Bejelentkezés Google-el"
    [stylingMode]="btnStylingMode"
  ></dx-button>
  <dx-button
    width="100%"
    icon="assets/icons/microsoft-logo.svg"
    text="Bejelentkezés Microsoft-al"
    [stylingMode]="btnStylingMode"
  ></dx-button>
</div>
